import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { pantryDisplayName } from '../../utils/pantryDisplayName';

/** `pantryDisplayName` in the app's language, so a row follows a switch in Settings. */
export function usePantryName() {
  const { i18n } = useTranslation();
  const language = i18n.language;
  return useCallback(
    (item: Parameters<typeof pantryDisplayName>[0]) => pantryDisplayName(item, language),
    [language]
  );
}
